import {Component, OnInit} from "@angular/core";
import {UtilsService} from "../../../core/utils/utils.service";
import {Subscription} from "rxjs";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {FormControl, FormGroup} from "@angular/forms";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {ToastService} from "../../../core/services/technique/toast.service";
import {DecoupageRepasDTO} from "../../../core/dtos/decoupagerepas-dto";
import {DecoupagesRepasService} from "../../../core/services/entities/decoupages-repas.service";

@Component({
  selector: 'yo-decoupage-repas-edition-dialog',
  templateUrl: './decoupage-repas-edition-dialog.component.html',
  styleUrls: ['./decoupage-repas-edition-dialog.component.scss']
})
export class DecoupageRepasEditionDialogComponent implements OnInit {

  decoupageRepas: DecoupageRepasDTO;

  dialogTitle: string;

  subOpenDialog: Subscription;

  displayDialog: boolean = false;

  sitePlaceholder: string;

  idSelectedSite: number;

  form: FormGroup;
  isCreateMode: boolean;

  constructor(private utilsSvc: UtilsService,
              private decoupageRepasSvc: DecoupagesRepasService,
              private i8nSvc: InternationalizationService,
              private auth2Svc: Auth2Service,
              private toastSvc: ToastService) {
  }

  ngOnInit() {
    this.initForm();
    this.openDialogEditionSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
  }

  openDialogEditionSubscription = (): void => {
    this.subOpenDialog = this.decoupageRepasSvc.openDialogEdition$
      .subscribe((r: DecoupageRepasDTO) => {
        this.displayDialog = true;
        this.isCreateMode = !r
        if (this.isCreateMode) {
          this.decoupageRepas = new DecoupageRepasDTO();
          this.dialogTitle = this.i8nSvc.getLabelFromCode("TITLE_CREATION_CUTTING_MEAL", null);
        } else {
          this.decoupageRepas = r;
          this.dialogTitle = this.i8nSvc.getLabelFromCode("TITLE_MODIFICATION_CUTTING_MEAL", null);
        }
        this.initForm();
      });
  };

  initForm = (): void => {
    this.sitePlaceholder = !this.canModify() ? this.decoupageRepas?.site?.libelle : 'Selectionner le site...';
    this.idSelectedSite = this.decoupageRepas?.site?.id;
    this.form = new FormGroup({
      libelle: new FormControl(this.decoupageRepas?.libelle),
      ordre: new FormControl(this.decoupageRepas?.ordre),
      actif: new FormControl(this.decoupageRepas?.actif != null ? this.decoupageRepas?.actif : true),
      code: new FormControl(this.decoupageRepas?.code)
    });
  };

  onChangeSite = ($event: any): void => {
    this.idSelectedSite = $event.selectedItem?.id;
  }

  canModify = () => {
    return this.decoupageRepasSvc.canModify(this.decoupageRepas);
  }

  save = (): void => {
    if (this.form.valid) {
      let item: DecoupageRepasDTO = {...this.decoupageRepas };
      item.site = {id: this.idSelectedSite } as SiteDTO;
      item.libelle = this.form.controls['libelle'].value;
      item.ordre = this.form.controls['ordre'].value;
      item.actif = this.form.controls['actif'].value;
      item.code = this.form.controls['code'].value;
      this.decoupageRepasSvc.save(item)
        .subscribe(response => {
          this.decoupageRepasSvc.announceDecoupageRepasSaved();
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Sauvegarde du découpage repas réalisé avec succès`);
          this.closeDialog();
        });
    } else {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Veuillez compléter le formulaire`);
    }
  }

  findAllLocalSites = (): SiteDTO[] => {
    return this.auth2Svc.utilisateur.siteListLocaux;
  }

  closeDialog = (): void => {
    this.displayDialog = false;
  };

}
